import React, { useState } from "react";
import { jsPDF } from "jspdf";
import "./NamunaNo8Form.css";

const NamunaNo8Form = () => {
  const [form, setForm] = useState({
    anuNo: "",
    malkacheName: "",
    mobile: "",
    bhogvtadaarName: "",
    malmatKr: "",
    readyReckon: "SANGALI",
    wardName: "निवडा",
    roadName: "निवडा",
    citySurveyNo: "",
    gatSurveyNo: "",
    malmat: "स्वतः",
    malmatType: "खाजगी मालकी",
    paniConnection: "सिंगल",
    singleConnection: "सार्वजनिक",
    itarKar: "नाही",
    shera: "",
    malmatDescription: "",
    buildingType: "आर. सी. सी.",
    length: "",
    width: "",
    area: "",
    buildingUse: "रहिवासी",
    buildingYear: "",
  });

  const [data, setData] = useState([]);
  const [editId, setEditId] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  const handleSubmit = () => {
    if (!form.malkacheName || !form.malmatKr || !form.malmatDescription) {
      alert("कृपया आवश्यक माहिती भरा!");
      return;
    }

    if (editId) {
      setData(
        data.map((item) =>
          item.id === editId ? { ...form, id: editId } : item
        )
      );
      alert("माहिती सफलतेने अपडेट झाली! ✅");
      setEditId(null);
    } else {
      setData([...data, { ...form, id: Date.now() }]);
      alert("माहिती यशस्वीरित्या जतन झाली! ✅");
    }

    resetForm();
  };

  const resetForm = () => {
    setForm({
      anuNo: "",
      malkacheName: "",
      mobile: "",
      bhogvtadaarName: "",
      malmatKr: "",
      readyReckon: "SANGALI",
      wardName: "निवडा",
      roadName: "निवडा",
      citySurveyNo: "",
      gatSurveyNo: "",
      malmat: "स्वतः",
      malmatType: "खाजगी मालकी",
      paniConnection: "सिंगल",
      singleConnection: "सार्वजनिक",
      itarKar: "नाही",
      shera: "",
      malmatDescription: "",
      buildingType: "आर. सी. सी.",
      length: "",
      width: "",
      area: "",
      buildingUse: "रहिवासी",
      buildingYear: "",
    });
    setEditId(null);
    setShowForm(false);
  };

  const deleteData = (id) => {
    if (window.confirm("हटवायचं आहे का?")) {
      setData(data.filter((item) => item.id !== id));
      if (editId === id) {
        resetForm();
      }
    }
  };

  const editData = (item) => {
    setForm(item);
    setEditId(item.id);
    setShowForm(true);
  };

  const generatePDF = async (specificId = null) => {
    try {
      const pdf = new jsPDF("p", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();

      pdf.setFillColor(79, 131, 163);
      pdf.rect(0, 0, pageWidth, 15, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.setFontSize(16);
      pdf.text("नमुना नं ८ - मालमत्ता तपशील", pageWidth / 2, 10, {
        align: "center",
      });

      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(10);
      pdf.text(`तारीख: ${new Date().toLocaleDateString("en-GB")}`, 15, 25);

      const exportData = specificId
        ? data.filter((item) => item.id === specificId)
        : data;

      const tableData = exportData.map((item, index) => [
        index + 1,
        item.malkacheName,
        item.mobile,
        item.malmatKr,
        item.buildingType,
        item.area || "0",
      ]);

      pdf.autoTable({
        head: [["अ.क्र.", "मालकाचे नाव", "मोबाईल", "मालमत्ता क्र.", "इमारत प्रकार", "क्षेत्रफळ"]],
        body: tableData,
        startY: 32,
        theme: "grid",
        headStyles: {
          fillColor: [79, 131, 163],
          textColor: [255, 255, 255],
          fontStyle: "bold",
          fontSize: 10,
        },
        bodyStyles: {
          textColor: [73, 80, 87],
          fontSize: 9,
        },
        alternateRowStyles: {
          fillColor: [248, 249, 250],
        },
      });

      const pageCount = pdf.internal.pages.length - 1;
      for (let i = 1; i <= pageCount; i++) {
        pdf.setPage(i);
        pdf.setFontSize(9);
        pdf.setTextColor(128, 128, 128);
        pdf.text(
          `पृष्ठ ${i} / ${pageCount}`,
          pageWidth / 2,
          pdf.internal.pageSize.getHeight() - 10,
          { align: "center" }
        );
      }

      const fileName = specificId
        ? `नमुना-नं-८-${specificId}.pdf`
        : `नमुना-नं-८-यादी.pdf`;
      pdf.save(fileName);
    } catch (error) {
      alert("PDF तयार करताना त्रुटी: " + error.message);
    }
  };

  return (
    <div className="namuna-container">
      <div className="namuna-header">नमुना नं ८ - मालमत्ता नोंदणी</div>

      {/* Button to Add New Property */}
      {!showForm && (
        <div className="namuna-action-bar">
          <button
            className="btn-add-new"
            onClick={() => {
              resetForm();
              setShowForm(true);
            }}
          >
            ➕ नई नोंदणी जोडा
          </button>
        </div>
      )}

      {/* Form Section */}
      {showForm && (
        <div className="form-container">
          {editId && (
            <div className="edit-mode-banner">
              ✏️ संपादन मोड (ID: {editId})
            </div>
          )}

          {/* माहिती Section */}
          <div className="form-section">
            <h3 className="section-title">माहिती</h3>

            <div className="form-grid grid4">
              <div className="form-field">
                <label>अनु नं.</label>
                <input
                  type="text"
                  name="anuNo"
                  value={form.anuNo}
                  onChange={handleChange}
                />
              </div>
              <div className="form-field">
                <label>
                  मालकाचे नाव <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="malkacheName"
                  value={form.malkacheName}
                  onChange={handleChange}
                  placeholder="मालकाचे नाव"
                />
              </div>
              <div className="form-field">
                <label>मोबाईल नं.</label>
                <input
                  type="tel"
                  name="mobile"
                  value={form.mobile}
                  onChange={handleChange}
                  placeholder="मोबाईल नं."
                />
              </div>
              <div className="form-field">
                <label>भोगवटादाराचे नाव</label>
                <input
                  type="text"
                  name="bhogvtadaarName"
                  value={form.bhogvtadaarName}
                  onChange={handleChange}
                  placeholder="भोगवटादाराचे नाव"
                />
              </div>
            </div>

            <div className="form-grid grid4">
              <div className="form-field">
                <label>
                  मालमत्ता क्र. <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="malmatKr"
                  value={form.malmatKr}
                  onChange={handleChange}
                  placeholder="मालमत्ता क्र."
                />
              </div>
              <div className="form-field">
                <label>रेडीरेकन</label>
                <select name="readyReckon" value={form.readyReckon} onChange={handleChange}>
                  <option>SANGALI</option>
                  <option>PUNE</option>
                </select>
              </div>
              <div className="form-field">
                <label>वॉर्ड नाव</label>
                <select name="wardName" value={form.wardName} onChange={handleChange}>
                  <option>निवडा</option>
                </select>
              </div>
              <div className="form-field">
                <label>रस्त्याचे नाव</label>
                <select name="roadName" value={form.roadName} onChange={handleChange}>
                  <option>निवडा</option>
                </select>
              </div>
            </div>

            <div className="form-grid grid4">
              <div className="form-field">
                <label>सिटी सर्व्हे नं.</label>
                <input
                  type="text"
                  name="citySurveyNo"
                  value={form.citySurveyNo}
                  onChange={handleChange}
                />
              </div>
              <div className="form-field">
                <label>गट/सर्व्हे नं.</label>
                <input
                  type="text"
                  name="gatSurveyNo"
                  value={form.gatSurveyNo}
                  onChange={handleChange}
                />
              </div>
              <div className="form-field">
                <label>मिळकत</label>
                <select name="malmat" value={form.malmat} onChange={handleChange}>
                  <option>स्वतः</option>
                </select>
              </div>
              <div className="form-field">
                <label>मिळकत प्रकार</label>
                <select name="malmatType" value={form.malmatType} onChange={handleChange}>
                  <option>खाजगी मालकी</option>
                </select>
              </div>
            </div>

            <div className="form-grid grid3">
              <div className="form-field">
                <label>पाणी कनेक्शन</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="paniConnection"
                      value="सिंगल"
                      checked={form.paniConnection === "सिंगल"}
                      onChange={handleChange}
                    />
                    सिंगल
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="paniConnection"
                      value="अनेक"
                      checked={form.paniConnection === "अनेक"}
                      onChange={handleChange}
                    />
                    अनेक
                  </label>
                </div>
              </div>
              <div className="form-field">
                <label>सींगल कनेक्शन</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="singleConnection"
                      value="सार्वजनिक"
                      checked={form.singleConnection === "सार्वजनिक"}
                      onChange={handleChange}
                    />
                    सार्वजनिक
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="singleConnection"
                      value="विशेष"
                      checked={form.singleConnection === "विशेष"}
                      onChange={handleChange}
                    />
                    विशेष
                  </label>
                </div>
              </div>
              <div className="form-field">
                <label>इतर कर</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="itarKar"
                      value="आहे"
                      checked={form.itarKar === "आहे"}
                      onChange={handleChange}
                    />
                    आहे
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="itarKar"
                      value="नाही"
                      checked={form.itarKar === "नाही"}
                      onChange={handleChange}
                    />
                    नाही
                  </label>
                </div>
              </div>
            </div>

            <div className="form-field form-textarea">
              <label>शेरा</label>
              <textarea
                name="shera"
                value={form.shera}
                onChange={handleChange}
                rows="3"
              />
            </div>
          </div>

          {/* मालमत्ता तपशील Section */}
          <div className="form-section section-property">
            <h3 className="section-title">मालमत्ता तपशील</h3>

            <div className="form-field form-textarea">
              <label>मालमत्तेचे वर्णन</label>
              <textarea
                name="malmatDescription"
                value={form.malmatDescription}
                onChange={handleChange}
                rows="3"
                placeholder="मालमत्तेचे वर्णन"
              />
            </div>

            <div className="form-grid grid4">
              <div className="form-field">
                <label>
                  इमारत प्रकार <span className="required">*</span>
                </label>
                <select name="buildingType" value={form.buildingType} onChange={handleChange}>
                  <option>आर. सी. सी.</option>
                  <option>ईंट</option>
                  <option>इतर</option>
                </select>
              </div>
              <div className="form-field">
                <label>लांबी (फुट)</label>
                <input
                  type="number"
                  name="length"
                  value={form.length}
                  onChange={handleChange}
                  placeholder="लांबी"
                />
              </div>
              <div className="form-field">
                <label>रुंदी (फुट)</label>
                <input
                  type="number"
                  name="width"
                  value={form.width}
                  onChange={handleChange}
                  placeholder="रुंदी"
                />
              </div>
              <div className="form-field">
                <label>क्षेत्रफळ (चौ.फुट)</label>
                <input
                  type="text"
                  name="area"
                  value={form.area || (form.length && form.width ? (form.length * form.width).toFixed(2) : "")}
                  onChange={handleChange}
                  placeholder="0"
                />
              </div>
            </div>

            <div className="form-grid grid2">
              <div className="form-field">
                <label>मालमत्ता उपयोग प्रकार</label>
                <div className="radio-group">
                  <label>
                    <input
                      type="radio"
                      name="buildingUse"
                      value="रहिवासी"
                      checked={form.buildingUse === "रहिवासी"}
                      onChange={handleChange}
                    />
                    रहिवासी
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="buildingUse"
                      value="वाणिज्यिक"
                      checked={form.buildingUse === "वाणिज्यिक"}
                      onChange={handleChange}
                    />
                    वाणिज्यिक
                  </label>
                  <label>
                    <input
                      type="radio"
                      name="buildingUse"
                      value="औद्योगिक"
                      checked={form.buildingUse === "औद्योगिक"}
                      onChange={handleChange}
                    />
                    औद्योगिक
                  </label>
                </div>
              </div>
              <div className="form-field">
                <label>मिळकत बांधकाम वर्ष</label>
                <input
                  type="number"
                  name="buildingYear"
                  value={form.buildingYear}
                  onChange={handleChange}
                  placeholder="वर्ष"
                />
              </div>
            </div>
          </div>

          {/* Form Buttons */}
          <div className="form-buttons">
            <button className="btn btn-save" onClick={handleSubmit}>
              जतन करा
            </button>
            <button className="btn btn-reset" onClick={resetForm}>
              रीसेट करा
            </button>
          </div>
        </div>
      )}

      {/* Data Table Section */}
      {!showForm && data.length > 0 && (
        <div className="table-container">
          <div className="table-header">
            <h3>नमुना नं ८ यादी ({data.length})</h3>
            <div className="pdf-buttons">
              <button
                className="btn-pdf-all"
                onClick={() => generatePDF()}
              >
                📄 सर्व PDF
              </button>
              {data.length === 1 && (
                <button
                  className="btn-pdf-specific"
                  onClick={() => generatePDF(data[0].id)}
                >
                  📋 निर्दिष्ट PDF
                </button>
              )}
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table className="data-table">
              <thead>
                <tr>
                  <th>अ.क्र.</th>
                  <th>मालकाचे नाव</th>
                  <th>मोबाईल</th>
                  <th>मालमत्ता क्र.</th>
                  <th>इमारत प्रकार</th>
                  <th>क्षेत्रफळ</th>
                  <th>क्रिया</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item, index) => (
                  <tr key={item.id}>
                    <td>{index + 1}</td>
                    <td>{item.malkacheName}</td>
                    <td>{item.mobile}</td>
                    <td>{item.malmatKr}</td>
                    <td>{item.buildingType}</td>
                    <td>{item.area}</td>
                    <td>
                      <div className="action-buttons">
                        <button
                          className="btn-edit"
                          onClick={() => editData(item)}
                        >
                          संपादन
                        </button>
                        <button
                          className="btn-delete"
                          onClick={() => deleteData(item.id)}
                        >
                          हटवा
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Empty State */}
      {!showForm && data.length === 0 && (
        <div className="empty-state">
          <p>📋 अद्याप कोणतीही नोंदणी नाही</p>
          <small>नई नोंदणी जोडण्यासाठी वरील बटण क्लिक करा</small>
        </div>
      )}
    </div>
  );
};

export default NamunaNo8Form;
